/*

Close button
Made by LP
-> A close button
-> Active

*/

import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

export const ReturnHomeButton = () => {
    const navigate = useNavigate();

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 2.5, duration: 1.5 }}
            style={{ marginTop: "2rem", display: "flex", justifyContent: "center" }}
        >
            <motion.button
                onClick={() => navigate("/")}
                style={{
                    position: "relative",
                    background: "transparent",
                    color: "#101A2C",
                    border: "2px solid #101A2C",
                    padding: "12px 28px",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    borderRadius: "50px",
                    cursor: "pointer",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    transition: "color 0.3s ease, border-color 0.5s ease",
                    backgroundClip: "padding-box",
                }}
                whileHover="hover"
                initial="rest"
                animate="rest"
                variants={{
                    rest: { color: "#101A2C", borderColor: "#101A2C" },
                    hover: { color: "#36a9e0", borderColor: "#36a9e0" },
                }}
            >
                <motion.span
                    variants={{
                        rest: { x: 0 },
                        hover: { x: 5 },
                    }}
                    transition={{ type: "spring", stiffness: 300 }}
                    style={{ display: "flex", alignItems: "center" }}
                >
                    <FaArrowLeft size={18} />
                </motion.span>
                Retour à l'accueil
            </motion.button>
        </motion.div>
    );
};

export default ReturnHomeButton;